module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-114x114-0ff97bd53f40cdfc33204c5a889bdf01.png";